import { render, staticRenderFns } from "./mail-merge.vue?vue&type=template&id=48c67e49&scoped=true&"
import script from "./mail-merge.vue?vue&type=script&lang=js&"
export * from "./mail-merge.vue?vue&type=script&lang=js&"
import style0 from "./mail-merge.vue?vue&type=style&index=0&id=48c67e49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c67e49",
  null
  
)

export default component.exports